import React, { useState } from "react";
import "./Home_faq.css";
import Accordion from "react-bootstrap/Accordion";
import Common_Title from "../../common_components/common_title/Common_Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const Home_faq = () => {
  const [activeKey, setActiveKey] = useState("0");

  const faqData = [
    {
      question: "What is the role of Profcyma?",
      answer:
        "Profcyma acts as your trusted education partner — helping you explore top online universities and courses, enroll with ease, and receive ongoing support throughout your learning journey.",
    },
    {
      question:
        "What if I’m confused about choosing the right course for my career?",
      answer:
        "No worries. Our expert academic counsellors understand your goals, strengths, and interests, and help you select the program that aligns best with your career aspirations.",
    },
    {
      question: "What if I miss a class during the course?",
      answer:
        "You won’t fall behind. Every session comes with recorded lectures and learning materials you can access anytime.",
    },
    {
      question: "Are the courses online or offline?",
      answer:
        "All programs are delivered online, allowing you to study from anywhere while balancing your job or personal commitments.",
    },
    {
      question: "Are there any additional benefits of enrolling through Profcyma?",
      answer:
        "Yes — you get personalised counselling, end-to-end admission assistance, education financing support (if needed), timely updates, and dedicated support throughout your program.",
    },
    {
      question:
        "HoHow can I refer a friend for any program listed on the Profcyma website?",
      answer:
        "You can simply share their contact details or have them mention your reference during counselling/enrollment. You may also submit referrals directly through our support team.",
    },
  ];

  return (
    <>
      <section className="Home_faq">
        <div className="container">
          <div className="title_holder">
            <Common_Title simpleText="Frequently Asked Questions " darkText="(FAQ)" />
          </div>

          <Accordion
            activeKey={activeKey}
            onSelect={(key) => setActiveKey(key)}
          >
            {faqData.map((item, index) => (
              <Accordion.Item eventKey={index.toString()} key={index}>
                <Accordion.Header>
                  <p className="question_text">{item.question}</p>

                  <div className="icon_holder">
                    <FontAwesomeIcon
                      icon={
                        activeKey === index.toString() ? faAngleUp : faAngleDown
                      }
                      className="icon_text"
                    />
                  </div>
                </Accordion.Header>

                <Accordion.Body>{item.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </section>
    </>
  );
};

export default Home_faq;
